/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Level_Born_Niklas_TripInputs */

const fr_level_born_niklas_trip = /** @type {(inputs: Level_Born_Niklas_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cochez cette case si votre PR actuel est inférieur à votre meilleur historique (ex:
				reprise après une pause)`)
};

/**

* @param {Level_Born_Niklas_TripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const level_born_niklas_trip = /** @type {((inputs?: Level_Born_Niklas_TripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Born_Niklas_TripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_level_born_niklas_trip(inputs)
});